//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import CheckList from "@/views/Sale/SlCheck/CheckList"
import CheckListPending from "@/views/Sale/SlCheck/CheckListPending"

//
export default {
    path: "check_payments",
    component: ModuleLayout,
    children: [
        {
            path: "",
            name: "cashing-check-payments",
            component: CheckList
        },
        {
            path: "pending",
            name: "cashing-check-payments",
            component: CheckListPending,
            meta: {
                title: "Listado de cheques pendientes",
            }
        },
    ],
    meta: {
        title: "Listado de cheques",
    }
}

//
export const CheckPendingRoutes = {
    path: "cashing_check_payments",
    component: ModuleLayout,
    children: [
        {
            path: "",
            name: "cashing-check-payments",
            component: CheckListPending,
            meta: {
                title: "Listado cheques",
            }
        },
    ],
    meta: {
        title: "Cheques por Cobrar",
    }
}